import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'issues',
    lazy: async () => ({ Component: (await import('./IssuesPage')).IssuesPage }),
  },
];
